import { render, staticRenderFns } from "./WsInfoRadio.vue?vue&type=template&id=36661c88&"
import script from "./WsInfoRadio.vue?vue&type=script&lang=js&"
export * from "./WsInfoRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports